// 接続矢印の経路・形状の編集（object.connector.update）を、いまのサーバへ送ってよいかの判定。
//
// サーバは REST bootstrap の応答で対応版（capabilities.connectorEditingVersion）を申告する。申告の無い
// 旧サーバ（配備の切り替え途中・切り戻し）は未知の op を応答なしで捨てるため、送ると保存されないまま
// 楽観表示だけが残る。そこで申告を確認できたときだけ編集 UI と op を有効にする。色・太さ（従来の
// object.style.update）は旧サーバも理解するため、この判定の対象にしない。
//
// 認証なしモード（開発・E2E）のリアルタイム通信はモック（自分の op をそのまま確定として返す）で、
// 新しい op も受け付けるため、REST の申告が取れなくても有効にする。

import { getWebConfig } from "../../env";
import { useCanvasDocStore } from "./store/canvas-doc-store";

/** このクライアントが対応している接続矢印の編集の版。 */
export const CONNECTOR_EDITING_VERSION = 1;

/** 編集できないときに利用者へ伝える文言。 */
export const CONNECTOR_EDITING_UNAVAILABLE_MESSAGE =
  "サーバの更新を確認できないため、接続矢印の経路と形は変更できません。ページを再読み込みしてからお試しください。";

/** 認証なしモード（リアルタイム通信がモック）か。設定が未初期化の環境（単体テスト）では false。 */
function isMockRealtimeMode(): boolean {
  try {
    return getWebConfig().authMode === "mock";
  } catch {
    return false;
  }
}

/** サーバの申告した版で、接続矢印の経路・形状の編集を送れるか。 */
export function isConnectorEditingAvailable(version: number | null): boolean {
  return version === CONNECTOR_EDITING_VERSION || isMockRealtimeMode();
}

/** 現在のキャンバスで、接続矢印の経路・形状の編集を送れるか（操作の直前に読む）。 */
export function connectorEditingAvailableNow(): boolean {
  return isConnectorEditingAvailable(useCanvasDocStore.getState().connectorEditingVersion);
}

/** 接続矢印の経路・形状の編集 UI を有効にするか（描画用の購読）。 */
export function useConnectorEditingAvailable(): boolean {
  return useCanvasDocStore((s) => isConnectorEditingAvailable(s.connectorEditingVersion));
}
